<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="80%"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-col :span="24">
      <el-alert
        title="All Users will be created with application set to Open360"
        type="error"
        show-icon
        :closable="false"
      />
      <el-row v-if="file">
        <DataTable
          ref="table"
          :key="tableKey"
          :data="parsed"
        />
      </el-row>
      <el-row
        v-if="!file"
        style="height: 200px; display: flex; align-items: center; justify-content: center;"
      >
        <el-upload
          ref="uploader"
          action=""
          accept=".CSV"
          drag
          :auto-upload="false"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          :limit="1"
          :on-exceed="onExceed"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div
            slot="tip"
            class="el-upload__tip"
          >
            CSV Files only, with headers: {{ pattern.join(', ') }}
          </div>
        </el-upload>
      </el-row>
    </el-col>
    <span
      slot="footer"
      :gutter="10"
      class="dialog-footer"
    >
      <el-button @click="dialogVisible = false">Cancel</el-button>
      <el-button
        type="primary"
        :loading="isUploading"
        @click="handleConfirm"
      >
        Confirm
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { papaparse } from '@/plugins/papaparse'
import DataTable from '@/components/Application/Manage/Users/Bulk/Table.vue'
export default {
  name: 'BulkModal',
  components: {
    DataTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableKey: 0,
      test: null,
      file: null,
      pattern: ['Full Name', 'Display Name', 'Email', 'Phone', 'Position', 'Timezone'],
      parsed: [],
      isUploading: false,
      timezones: []
    }
  },
  computed: {
    title () {
      return 'Bulk User Import' + (this.file ? ` - ${this.file.name}` : '')
    }
  },
  watch: {
    isUploading (val) {
      if (!val) {
        console.log('Bulk import completed, updating table...')
        this.$refs.table.$forceUpdate()
      }
    }
  },
  created () {
    this.$sdk.timezone.list((builder) => {
      builder.filters = { timezone: 'Australia' }
    })
      .then(res => {
        this.timezones = res
      })
      .finally(() => { this.isLoading = false })
  },
  methods: {
    onFileChange (file, fileList) {
      this.file = file
      this.parseCSV()
    },
    onFileRemove (file, fileList) {
      this.$emit('selected', null)
    },
    onExceed (files, fileList) {
      this.$message({ message: 'Only 1 file can be uploaded at a time', type: 'error' })
    },
    parseCSV () {
      papaparse.parse(this.file.raw, {
        header: true,
        worker: true,
        skipEmptyLines: true,
        complete: res => {
          res.data.map(row => {
            row.uuid = undefined
          })
          this.headers = res.meta.fields.filter(field => !this.pattern.some(p => field.startsWith(p)))
          const isMatchedPattern = !this.$_.isEmpty(res.meta.fields.filter(field => this.pattern.some(p => field.startsWith(p))))
          if (isMatchedPattern) {
            console.log('Matched pattern:', this.pattern)
            this.parsed = res.data
          } else {
            this.errorMsg = 'Failed to find pattern in this file.'
            this.parsed = res.data
          }
        }
      })
    },
    async handleConfirm () {
      this.isUploading = true

      // Create an array of promises, each representing a profile creation attempt for a row.
      const profileCreationPromises = this.parsed.map(async (row, index) => {
        // Vue 2 reactivity: Directly modifying properties of an object inside an array
        // is reactive IF the object itself was already reactive (i.e., part of `data`).
        // No need for Vue.set here unless you're adding NEW properties to an existing object.
        row.status = 'Pending'
        row.uuid = undefined // Ensure uuid is reset for each row

        const formatted = {
          name_full: row['Full Name'],
          name_display: row['Display Name'],
          email: row.Email,
          phone_primary: row.Phone ? row.Phone.replace(/[^0-9]/g, '') : '', // Handle potential undefined Phone
          position: row.Position,
          time_zone: this.timezones.find(tz => tz.zone === row.Timezone) || null,
          firebase_id: 'open360'
        }
        console.log('Attempting to create profile for:', formatted.email)

        try {
          const profile = await this.$sdk.profile.create(formatted)
          // Success: Update the original row object directly.
          // Vue will react to this change if 'row' is reactive.
          row.uuid = profile.uuid
          row.status = 'Success'
          console.log('Profile created successfully for:', formatted.email, 'UUID:', profile.uuid)
        } catch (err) {
          // Failure: Update the original row object directly.
          row.status = 'Failed'
          // You might want to store the error message as well for display
          row.errorMessage = err.message || 'Unknown error'
          console.error('Failed to create profile for:', formatted.email, 'Error:', err)
        }
        // Return the row itself or any other relevant info if you want to
        // process the results of Promise.allSettled later, though for UI updates
        // it's not strictly necessary as we're modifying 'row' directly.
        return row
      })

      // Wait for all promises to settle (either fulfill or reject).
      // This ensures `this.isUploading = false` only runs after all attempts are done.
      await Promise.allSettled(profileCreationPromises)

      this.isUploading = false
      this.tableKey++ // Force re-render of the table to reflect changes
      console.log('All profile creation attempts have settled. Table should be updated.')
    },
    handleClose (done) {
      this.$confirm('Are you sure to close this dialog?')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>
